import React, { useEffect, useState, useRef } from "react";
import { Column } from "devextreme-react/data-grid";
import { AdminTable } from "./AdminTable";
import { useDispatch, useSelector } from "react-redux";
import { createExternalUser, createUser, deleteExternalUser, deleteUser, getExternalUsers, getUsers, getUsersWithRoles, updateExternalUser, updateUser } from "../../redux/users/thunks";
import { selectExternalUsers, selectExternalUsersLoading, selectUsers, selectUsersLoading } from "../../redux/users/selectors";
import { openModal } from "../../redux/modal/modalSlice";
import { SecretCell } from "./SecretCell";

const initialSortOptions = {
    columna: "externalUserId",
    sortOrderAsc: true

}

function ExternalUserManagement() {
    const dispatch = useDispatch();
    const externalUsers = useSelector(selectExternalUsers);
    const users = useSelector(selectUsers);
    const loading = useSelector(selectExternalUsersLoading);
    const numElements = [10, 20, 30];
    const [sortOptions, setSortOptions] = useState(initialSortOptions)
    
    useEffect(() => {
        getExtUsers(mapPageInfo(externalUsers));
        dispatch(getUsers())
    }, [])

    function mapPageInfo(users) {
        return {
            pageIndex: users.pageIndex ?? 0,
            pageSize: users.pageSize ?? 10,
            orderByField: users.columna ?? "externalUserId",
            orderByAscending: users.sortOrderAsc ?? true
        }
    }

    const getExtUsers = (pageInfo) => {
        let query = `?pageIndex=${pageInfo.pageIndex}&pageNum=${pageInfo.pageSize}`
        if(pageInfo.searchString?.trim().length > 0){
            query = query.concat(`&searchString=${pageInfo.searchString.trim()}`)
        }
        if(pageInfo.orderByField)
            {
                query = query.concat(`&orderByField=${pageInfo.orderByField}&orderByAscending=${pageInfo.orderByAscending}`)
            }
        dispatch(getExternalUsers({ query : query }));
    }

    const handleSaveNew = (userForm, closeDialog, sorting) => {
        if(!userForm.client || userForm.client.trim() === ""){
            dispatch(openModal({type:"warning", message: "Por favor, preencha o campo Nome de usuário"}))
            return
        }
        if(!userForm.clientSecret || userForm.clientSecret.trim() === ""){
            dispatch(openModal({type:"warning", message: "Por favor, preencha o campo Senha"}))
            return
        }

        if(!userForm.userId){
            dispatch(openModal({type:"warning", message: "Por favor, preencha o campo Usuário"}))
            return
        }

            dispatch(createExternalUser({body:userForm})).then((data) => {
                if (data.error)
                    dispatch(openModal({ type: "warning", message: data.error.message }))
                else {
                    getExtUsers(mapPageInfo({...externalUsers, ...sortOptions}));
                    closeDialog();
                }
            })
        
    }

    const handleSaveEdit = (userForm, closeDialog, sorting) => {
        if(userForm.client.trim() === ""){
            dispatch(openModal({type:"warning", message: "Por favor, preencha o campo Nome de usuário"}))
            return
        }
        if(userForm.clientSecret.trim() === ""){
            dispatch(openModal({type:"warning", message: "Por favor, preencha o campo Senha"}))
            return
        }

        if(!userForm.userId){
            dispatch(openModal({type:"warning", message: "Por favor, preencha o campo Usuário"}))
            return
        }

        const params = {
                body: userForm,
                param: userForm.externalUserId}

        dispatch(updateExternalUser(params)).then((data) => {
            if (data.error)
                dispatch(openModal({ type: "warning", message: data.error.message }))
            else {
                const userPageInfo = {...externalUsers, ...sortOptions}
                getExtUsers(mapPageInfo(userPageInfo));
                getExtUsers(externalUsers);
                closeDialog();
            }
        })
    }
    

    const handleDelete = (externalUserId, closeDialog, sorting) => {
        dispatch(deleteExternalUser({ param: externalUserId })).then((data) => {
            if (data.error)
                dispatch(openModal({ type: "warning", message: data.error.message }))
            else {
                let updatedPageIndex = externalUsers.pageIndex;

                if (externalUsers.elements.length === 1) {
                    updatedPageIndex = Math.max(0, externalUsers.pageIndex - 1);
                }

                const updatedUsers = {
                    ...externalUsers,
                    pageIndex: updatedPageIndex,
                };
                const userPageInfo = {...externalUserId, ...sortOptions}
                getExtUsers(mapPageInfo(userPageInfo));
                closeDialog()
            }
        })
    }

    const columnsUsers= [
        <Column sortIndex={1} allowEditing={false} key={"external-users-1"} dataField = "externalUserId" caption="Id" />,
        <Column key={"external-users-2"} dataField = "client" caption="Nome de usuário" />,
        <Column key={"external-users-3"} dataType={"password"} dataField = "clientSecret" caption="Senha" cellRender={(rowData)=><SecretCell secret={rowData.value}/>}/>,
        <Column key={"external-users-4"} lookup={{multiple: false, allowClearing: false, dataSource: users, displayExpr:'userName', valueExpr:'userId'}} dataField = "userId" caption="Usuário" />,
    ]

    return (
        <div style={{width: "100%"}}>
            <AdminTable 
                sectionTitle={"Usuários externos"}
                masterTitle={"Usuário externo"} 
                itemIdField={"externalUserId"} 
                itemDescriptionField={"client"} 
                loading={loading} 
                dataSource={externalUsers} 
                columnasTabla={columnsUsers} 
                numElements={numElements} 
                getData = { getExtUsers } 
                onCreate={handleSaveNew} 
                onEdit={handleSaveEdit} 
                onDelete={handleDelete}
                sortField={sortOptions}
                setsortField={setSortOptions}
                />
        </div>
    )
}

export  {ExternalUserManagement}
